module.exports = __webpack_public_path__ + "static/img/pd_empty.84de90e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/pd_empty.png
// module id = qBEi
// module chunks = 1